import membersAPI from './team-items-data.js';

/*-----------------------------------------------
|  Dynamic Team Items
-----------------------------------------------*/
const teamItemsInit = () => {
    const Selector = {
        SWIPER_WRAPPER: '.swiper.members-swiper',
        DATA_SWIPER: '[data-swiper]',
        TEAM_ITEM: '.swiper-slide.team-item'
    };

    let swiperWrapper = document.querySelector(Selector.SWIPER_WRAPPER);
    let swiper = null;
    const CWD = window.CWD || '';

    /**
     * Find the swiper instance associated with the members container
     */
    const findSwiperInstance = () => {
        const swiperElement = document.querySelector(Selector.DATA_SWIPER);
        if (swiperElement && window.Swiper) {
            swiper = swiperElement.swiper;
        }
    };


    const createTeamItemHtml = (memberData) => {
        const { img, name, designation } = memberData;

        return `
        <div class="swiper-slide px-2 team-item mb-4">
      <div class="hoverbox w-100 rounded-circle overflow-hidden mx-auto">
        <img src="${CWD}assets/img/venn/members/${img}" alt="" class="img-fluid">
        <div class="hoverbox-content">
          <div class="d-flex align-items-end justify-content-center h-100">
          </div>
        </div>
      </div>
      <div class="fw-bold mt-2 mb-1">
        <span class="fs-1 text-black">${name}</span>
      </div>
      <div class="team-title ls-1">${designation}</div>
      </div>
    `;
    };

    /**
     * Clear all team members and rebuild from current data
     */
    const rebuildTeamItems = () => {
        if (!swiperWrapper) return;

        // Rebuild from current data
        const allMembers = membersAPI.getAllMembers();
        const allMembersHtml = [];
        allMembers.forEach(memberData => {
            const teamItemElement = createTeamItemHtml(memberData);
            allMembersHtml.push(teamItemElement);
        });

        // Update swiper
        if (swiper) {
            swiper.removeSlide(0);
            swiper.appendSlide(allMembersHtml);
            swiper.update();
        }
    };

    /**
     * Load team members from data and populate the swiper
     */
    const loadTeamItems = () => {
        rebuildTeamItems();
    };

    /**
     * Get the current swiper instance
     * @returns {Object|null} Swiper instance or null
     */
    const getSwiperInstance = () => {
        return swiper;
    };

    /**
     * Refresh the swiper instance reference
     */
    const refreshSwiperInstance = () => {
        findSwiperInstance();
    };

    // Initialize swiper reference
    findSwiperInstance();

    // Create team manager object with public methods
    const teamManager = {
        rebuildTeamItems,
        loadTeamItems,
        getSwiperInstance,
        refreshSwiperInstance
    };

    // Make it available globally for easy access
    window.teamManager = teamManager;

    // Load team items from data
    setTimeout(() => {
        loadTeamItems();
    }, 100);

    return teamManager;
};

export default teamItemsInit;